import { CloseIcon } from "components/icons"
import { SearchPopupContent as BaseSearchPopupContent } from "components/domains/search"
import { useVenue } from "providers/venue"
import { VenueSelector } from "components/VenueSelector"
import { HorizontalDirectoryOccupantCard } from "../../directory/HorizontalDirectoryOccupantCard"
import { HorizontalDirectorySkeletonCard } from "../../directory/HorizontalDirectorySkeletonCard"

export const SearchPopupContent = (props) => {
  const { setVenueFilter, venueFilter, searchResultProps, ...restProps } = props
  const { venues = [] } = useVenue()
  return (
    <BaseSearchPopupContent
      {...restProps}
      closeIcon={CloseIcon}
      searchResultProps={{
        ...searchResultProps,
        renderSearchItem: HorizontalDirectoryOccupantCard,
        renderLoadingItem: HorizontalDirectorySkeletonCard,
      }}
      searchBasePopupProps={{
        dialogProps: { disablePortal: true, hideBackdrop: false },
      }}
      venueFilterComponent={
        <VenueSelector
          selectedVenue={venueFilter}
          onClickVenue={setVenueFilter}
          venues={venues}
        />
      }
    />
  )
}
